import React, { useEffect, useMemo, useState } from "react";
import { Box, TextField, Button, Tooltip } from "@material-ui/core";

import { NumberFormatCustom } from "src/utils/NumberFormatCustom";

import { PopUp } from "../../BasePopUp";
import { useLayout, useTimeleft } from "src/utils/customHook";
import BaseDrawer from "../../BaseDrawer";
import authService from "src/services/authService";
import ErrorBox from "src/components/ErrorBox";
import useRequestResetPassword from "src/hooks/rest/useRequestResetPassword";
import { clientError } from "src/context/errors";
import { ERROR_CODE } from "src/context/constants/errorCode";
import { banOTPErrorType } from "src/types/error-types";

// const useStyles = makeStyles((theme) => ({
//   root:{}
// }));

interface ForgotPasswordFillPopupProps {
  open: boolean;
  onClose: () => void;
  onSuccess: (phoneNumber: string) => void;
  openLogin?: () => void;
  title?: string;
  brokerID?: string;
  brokerName?: string;
}

const ForgotPasswordFillPopup: React.FC<ForgotPasswordFillPopupProps> = ({
  open,
  onClose,
  openLogin,
  title,
  brokerID,
  brokerName,
  onSuccess,
}) => {
  const { isSmall } = useLayout();
  const { loading, requestResetPassword } = useRequestResetPassword();
  const { timeLeft, restartCount, resetCount } = useTimeleft(30);

  const [phoneNo, setPhoneNo] = useState<string>("");
  const [errorMessage, setErrorMessage] = useState<string>("");

  useEffect(() => {
    if (open) {
      setPhoneNo("");
      setErrorMessage("");
      resetCount();
    }
  }, [open]);

  const _timeLeftMessage = (timeLeft: number) => {
    const minutes = Math.floor(timeLeft / 60);
    const seconds = timeLeft - 60 * minutes;
    if (minutes > 0) return `${minutes} นาที ${seconds} วินาที`;
    return `${seconds} วินาที`;
  };

  const timeLeftMessage = useMemo(() => {
    return _timeLeftMessage(timeLeft);
  }, [timeLeft]);

  const isBan = useMemo(() => {
    if (timeLeft > 0) return true;
    return false;
  }, [timeLeft]);

  const banErrorCallback = (err: banOTPErrorType) => {
    if (err.code === ERROR_CODE.OTP_BAN) {
      setErrorMessage(
        `กรุณารอ ${_timeLeftMessage(
          err.second
        )} ก่อนรีเซ็ตรหัสผ่านด้วยเบอร์โทรศัพท์นี้อีกครั้ง`
      );
      if (err.second) restartCount(err.second);
    }
  };

  const onResetPassword = async () => {
    if (!brokerID) return setErrorMessage(clientError.missingBrokerID.message);
    const data = await requestResetPassword(brokerID, phoneNo);
    if (data.code === ERROR_CODE.OTP_BAN) return banErrorCallback(data.error);
    if (data.errorMessage) return setErrorMessage(data.errorMessage);
    onSuccess(phoneNo);
  };

  const onChangePhoneNumber = (value: string) => {
    setPhoneNo(value);
    setErrorMessage("");
  };

  const RenderContent = (
    <Box>
      <Box mt={2} />
      <ErrorBox
        open={!!errorMessage}
        message={errorMessage}
        onClose={() => setErrorMessage("")}
      />
      <Box mt={2} />
      <TextField
        label="เบอร์มือถือ"
        fullWidth
        value={phoneNo}
        placeholder="0XX-XXX-XXXX"
        variant="filled"
        type="tel"
        helperText="เราจะส่ง SMS เพื่อให้แน่ใจว่าเป็นเบอร์ของคุณ"
        onChange={(e) => onChangePhoneNumber(e.target.value)}
        InputProps={{
          inputComponent: NumberFormatCustom as any,
        }}
        onKeyPress={(e) => {
          if (e.key === "Enter") {
            onResetPassword();
          }
        }}
      />
      <Box mt={10} />
      <Tooltip
        title={
          isBan
            ? `กรุณารอ ${timeLeftMessage} ก่อนรีเซ็ตรหัสผ่านด้วยเบอร์โทรศัพท์นี้อีกครั้ง`
            : ""
        }
        arrow
      >
        <span>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            size="large"
            onClick={onResetPassword}
            disabled={loading || phoneNo.length !== 10 || isBan}
          >
            ส่ง OTP
          </Button>
        </span>
      </Tooltip>
    </Box>
  );

  if (isSmall)
    return (
      <BaseDrawer
        title={title || "ยืนยันหมายเลขโทรศัพท์"}
        open={open}
        onClose={onClose}
      >
        {RenderContent}
      </BaseDrawer>
    );

  return (
    <PopUp
      title={title || "ยืนยันหมายเลขโทรศัพท์"}
      open={open}
      handleClose={onClose}
    >
      {RenderContent}
    </PopUp>
  );
};

export default ForgotPasswordFillPopup;
